'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getValue = require('./getValue');

var _getValue2 = _interopRequireDefault(_getValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValues = function getValues(skills, userSkills, jobSkills, constants) {
  return skills.map(function (_ref) {
    var id = _ref.id;

    return (0, _getValue2.default)(userSkills[id], jobSkills[id], constants);
  });
};

exports.default = getValues;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/skills/getValues.js
// module id = 1320
// module chunks = 0